import { ZoneListErrorTypes } from '../Zones/ZoneListTypes';

export type ValidatorReportRuleLevelType = 'error' | 'warning' | 'info';

export type ValidatorReportItemType = {
    itemId: number | null;
    messageId: string | null;
    message: string;
    level: ValidatorReportRuleLevelType;
    details: Object | null;
    zoneId: string | null;
    timestamp: number | null;
};

export class ValidatorReport {
    private items: ValidatorReportItemType[] = [];

    public addError(
        itemId: number | null,
        message: string,
        details: Object | null = null,
        zoneId: string | null = null,
        messageId: string | null = null,
        timestamp: number | null = null
    ) {
        this.items.push({
            itemId,
            messageId,
            message,
            level: 'error',
            details,
            zoneId,
            timestamp
        });
    }

    public addWarning(
        itemId: number | null,
        message: string,
        details: Object | null = null,
        zoneId: string | null = null,
        messageId: string | null = null,
        timestamp: number | null = null
    ) {
        this.items.push({
            itemId,
            messageId,
            message,
            level: 'warning',
            details,
            zoneId,
            timestamp
        });
    }

    public addInfo(
        itemId: number | null,
        message: string,
        details: Object | null = null,
        zoneId: string | null = null,
        messageId: string | null = null,
        timestamp: number | null = null
    ) {
        this.items.push({
            itemId,
            messageId,
            message,
            level: 'info',
            details,
            zoneId,
            timestamp
        });
    }

    public getItems() {
        return this.items;
    }

    public countErrors(): number {
        return this.items.filter(item => item.level === 'error').filter((item, index, self) => {
                return !item.messageId || index === self.findIndex(t => t.messageId === item.messageId);
            }).length;
    }

    public hasMessagesForRuleId(
        ruleId: number | null,
        level: ValidatorReportRuleLevelType | null = null
    ): boolean {
        if (level === null) {
            return this.getItems().find(item => item.itemId === ruleId) !== undefined;
        } else {
            return (
                this.getItems().find(item => item.itemId === ruleId && item.level === level) !==
                undefined
            );
        }
    }

    public getMessagesForRuleId(
        ruleId: number | null,
        level: ValidatorReportRuleLevelType | null = null,
        removeDuplicates: boolean = true
    ): ValidatorReportItemType[] {
        let output: ValidatorReportItemType[] = [];
        if (level === null) {
            output = this.getItems().filter(item => item.itemId === ruleId);
        } else {
            output = this.getItems().filter(item => item.itemId === ruleId && item.level === level);
        }
        output.sort((itemA, itemB) => (itemB.timestamp ?? 0) - (itemA.timestamp ?? 0));
        if (removeDuplicates) {
            output = output.filter((item, index, self) => {
                return !item.messageId || index === self.findIndex(t => t.messageId === item.messageId);
            });
        }
        return output;
    }

    public getMessagesForZoneId(zoneId: string): ValidatorReportItemType[] {
        let output: ValidatorReportItemType[] = this.getItems()
            .filter(item => item.zoneId === zoneId)
        //remove duplicates
        output = output.filter((item, index, self) => {
            return index === self.findIndex(t => t.messageId === item.messageId);
        });
        return output;
    }
}
